const DRAW_HISTORY = {
  section: {
    name: 'draw-history',
    caption: 'DRAW HISTORY'
  },
  sectionFields: [
    { label: 'App #', template: '{applicationNo}', fieldKey: 'applicationNo' },
    { label: 'DRAW DATE', template: '{drawDate}', fieldKey: 'drawDate', format: 'date' },
    { label: 'AMOUNT', template: '{amount}', fieldKey: 'amount', format: 'currency' },
    { label: 'DUE DATE', template: '{dueDate}', fieldKey: 'dueDate', format: 'date' },
    { label: 'STATUS', template: '{applicationStatusText}', fieldKey: 'applicationStatusText' }
  ]
}
export default DRAW_HISTORY
